<section>
    <app-title />
</section>
<section>
    <div class="funcionalidades-container">
        <div>
            <h1>Transforme ideias em números</h1>
            <p>Mantenha seus projetos dentro do orçamento em qualquer plataforma.</p>
        </div>
        <div>
            <img src="../../../assets/ideias.png" />
        </div>

        <div>
            <img src="../../../assets/ideias.png" />
        </div>
        <div>
            <h1>Controle o andamento da obra</h1>
            <p>Gerencie o progresso diário da equipe com o cronograma Gantt.</p>
        </div>

        <div>
            <h1>Otimize sua estratégia financeira</h1>
            <p>Identifique os investimentos de impacto com a curva ABC.</p>
        </div>
        <div>
            <img src="../../../assets/ideias.png" />
        </div>

        <div>
            <img src="../../../assets/ideias.png" />
        </div>
        <div>
            <h1>Mantenha suas finanças sob controle</h1>
            <p>Garanta a viabilidade financeira do seu orçamento com o BDI.</p>
        </div>

        <div>
            <h1>Personalize seus orçamentos</h1>
            <p>Crie pacotes de acordo com as necessidades de suas obras.</p>
        </div>
        <div>
            <img src="../../../assets/ideias.png" />
        </div>
    </div>
</section>

<section id="avaliacoes">
    <app-avaliacoes />
</section>

<section id="faq">
    <app-faq />
</section>

<section>
    <app-call-to-action />
</section>

<section id="contato">
    <app-fale-conosco />
</section>